import { Flag, Pause, Play, RotateCcw } from "lucide-react";

const presets = {
  Constructive: 240,
  Crossfire: 180,
  Rebuttal: 240,
  Summary: 180,
  "Grand Crossfire": 180,
  "Final Focus": 120,
  "Prep time": 180,
};

const formatTime = (seconds) =>
  `${String(Math.floor(seconds / 60)).padStart(2, "0")}:${String(seconds % 60).padStart(2, "0")}`;

export default function RoundTimer({
  seconds,
  isRunning,
  activePreset,
  isRoundEnded,
  isRoundStarted,
  onEndRound,
  onPreset,
  onToggle,
  onReset,
}) {
  return (
    <section
      className="timer-section section-reveal delay-two"
      data-testid="round-timer-section"
    >
      <div className="timer-label">
        <span className="status-pulse"></span>
        {isRoundEnded ? "Round ended" : isRunning ? "In progress" : "Round timer"}
      </div>
      <div className="timer-readout" data-testid="timer-display">
        {formatTime(seconds)}
      </div>
      <div className="timer-controls">
        <button
          className="timer-primary"
          onClick={onToggle}
          disabled={isRoundEnded}
          data-testid="timer-toggle-button"
        >
          {isRunning ? <Pause size={18} /> : <Play size={18} />}
          {isRunning ? "Pause" : "Start"}
        </button>
        <button
          className="timer-end-round"
          onClick={onEndRound}
          disabled={!isRoundStarted || isRoundEnded}
          title={
            isRoundEnded
              ? "This round has ended"
              : "Start the main timer before ending the round"
          }
          data-testid="end-round-button"
        >
          <Flag size={17} />
          End Round
        </button>
        <button
          className="timer-reset"
          onClick={onReset}
          disabled={isRoundEnded}
          data-testid="timer-reset-button"
          title="Reset timer"
        >
          <RotateCcw size={18} />
        </button>
      </div>
      <div className="preset-list" data-testid="timer-presets">
        {Object.entries(presets).map(([label, value]) => (
          <button
            key={label}
            className={activePreset === label ? "preset active" : "preset"}
            onClick={() => onPreset(label, value)}
            disabled={isRoundEnded}
            data-testid={`timer-preset-${label.toLowerCase().replaceAll(" ", "-")}`}
          >
            <span>{label}</span>
            <strong>{formatTime(value)}</strong>
          </button>
        ))}
      </div>
    </section>
  );
}
